import "./interface.scss";

import PropTypes from "prop-types";
import React from "react";

import {
  IDENTIFIER_SHRINK_MIN_WIDTH,
  TABLE_IDENTIFIER_SLUG_MARGIN_X,
  TABLE_IDENTIFIER_SLUG_MIN_WIDTH
} from "../../constants";
import Dimensions, { scalePixelsToFontSize } from "../../constants/styles/dimensions";
import { PropTypeShapes } from "../../types";
import { withCharacterContext } from "../character/CharacterContext";
import Avatar from "./Avatar";

const getIdFontSize = fontSize => scalePixelsToFontSize(Dimensions.IDENTIFIER.FONT_SIZE, fontSize, true);

// Old function for limiting width and shrinking
// See https://aeontimeline.atlassian.net/browse/ATR-1927
const getAutoAdjustIdentifierStyle = useProps => {
  const { characterContext, size } = useProps;
  const fontSize = characterContext.getFontSize();
  const idFontSize = getIdFontSize(fontSize);
  const scaledShrinkMin = scalePixelsToFontSize(IDENTIFIER_SHRINK_MIN_WIDTH, idFontSize);
  const scaledMin = scalePixelsToFontSize(TABLE_IDENTIFIER_SLUG_MIN_WIDTH, idFontSize);
  const scaledMarginX = scalePixelsToFontSize(TABLE_IDENTIFIER_SLUG_MARGIN_X, idFontSize);
  const hasWidth = size && size.width;
  const isLongLabel = hasWidth && size.width > scaledShrinkMin;
  // Larger than min but smaller than shrink min
  const minWidth = isLongLabel ? scaledShrinkMin : scaledMin;
  return {
    flex: hasWidth && isLongLabel ? `1 1 ${minWidth}px` : null,
    minWidth: minWidth,
    maxWidth: hasWidth ? size.width - scaledMarginX : null
  };
};

const getIdentifierStyle = useProps => {
  const { characterContext } = useProps;
  const fontSize = characterContext.getFontSize();
  const idFontSize = getIdFontSize(fontSize);
  const normalStyle = { fontSize: idFontSize, maxHeight: useProps.size ? useProps.size.height : null };
  const dynamicAdjustStyle = useProps.dynamicAdjustment ? getAutoAdjustIdentifierStyle(useProps) : {};
  return Object.assign(normalStyle, dynamicAdjustStyle);
};

const Identifier = props => {
  return props.isAvatar ? (
    <Avatar
      image={props.image}
      initials={props.label}
      tooltip={props.tooltip}
      color={props.color}
      onClick={props.onClick}
    />
  ) : props.label ? (
    <div
      className={`identifierSlug ${props.color}`}
      style={getIdentifierStyle(props)}
      title={props.tooltip}
      onClick={props.onClick}
    >
      {props.label}
    </div>
  ) : null;
};

Identifier.propTypes = {
  isAvatar: PropTypes.bool,
  image: PropTypes.string,
  label: PropTypes.string,
  color: PropTypes.string,
  tooltip: PropTypes.string,
  onClick: PropTypes.func,
  size: PropTypeShapes.size,

  // Auto shrink to fit dynamically
  // dynamicAdjustment: PropTypes.bool,

  // From character context
  characterContext: PropTypes.object.isRequired
};

export default withCharacterContext(Identifier);
